import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
export interface PayrollDetailsStatusChipProps {
  statusSerialNumber: number;
}
export const getPayrollStatus: (statusSerialNumber: number) => {
  value: string;
  color: 'default' | 'success' | 'info' | 'error' | 'warning';
} = statusSerialNumber => {
  switch (statusSerialNumber) {
    case 0:
      return { value: 'Pending', color: 'warning' };
    case 1:
      return { value: 'Executed', color: 'success' };
    case 2:
      return { value: 'Failed', color: 'error' };
    case 3:
      return { value: 'Cancelled', color: 'error' };
    case 4:
      return { value: 'ForecastSuccess', color: 'success' };
    case 5:
      return { value: 'ForecastFailed', color: 'error' };
    case 6:
      return { value: 'InProcess', color: 'warning' };
    default:
      return {
        value: '-',
        color: 'default',
      };
  }
};
const PayrollDetailsStatusChip: FC<PayrollDetailsStatusChipProps> = ({ statusSerialNumber }) => (
  <Chip label={getPayrollStatus(statusSerialNumber).value} bgColor={getPayrollStatus(statusSerialNumber).color} />
);
export { PayrollDetailsStatusChip };
